import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from 'antd';
import Color from 'color';
import styled from 'styled-components';
import { useAccount } from 'hooks/use-account';
const { Footer: AntFooter } = Layout;
const StyledFooter = styled(AntFooter)`
  align-items: center;
  color: var(--side-nav-text);
  display: flex;
  text-align: center;
  background: ${({ sideNavBg })=>sideNavBg};
  z-index: 2;
`;
export const Footer = ({ children })=>{
    var _ref;
    var _metaData_theme;
    const { metaData } = useAccount();
    const defaultNavBg = '#161616';
    const sideNavColour = (_ref = (_metaData_theme = metaData.theme) === null || _metaData_theme === void 0 ? void 0 : _metaData_theme.sideNavBg) !== null && _ref !== void 0 ? _ref : defaultNavBg;
    return /*#__PURE__*/ _jsx(StyledFooter, {
        sideNavBg: Color(sideNavColour).darken(0.6).hex(),
        children: children
    });
};
